<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wykonany nakład
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model.number="reportAmount"
                            v-mask="'#######'"
                            label="Nakład"
                            outlined
                            dense
                            :hint="reportLeftAmountInfo"
                            persistent-hint
                            :error="reportAmountErrors"
                        />
                    </v-col>
                </v-row>
            </div>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    @click="onSave"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, integer, minValue, maxValue } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'AmountToReportDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        reportData: {
            type: Object,
            default: null
        },
        reportStatus: {
            type: Number,
            default: null
        },
        allowsReportExcessAmount: {
            type: Boolean
        }
    },
    data() {
        return {
            reportAmount: null,
            report: {}
        }
    },
    validations() {
        return {
            reportAmount: {
                required,
                integer,
                minValue: minValue(0),
                maxValue: !this.allowsReportExcessAmount ? maxValue(this.report.leftAmount) : maxValue(9999999)
            }
        }
    },
    computed: {
        reportLeftAmount() {
            return this.report.leftAmount ? this.report.leftAmount : 0
        },
        reportLeftAmountInfo() {
            const amount = this.reportAmount ? this.reportAmount : 0

            return `${amount} / ${this.reportLeftAmount}`
        },
        reportAmountErrors() {
            if (!this.$v.reportAmount.$dirty) return

            return this.$v.reportAmount.$invalid
        },
        workspaceSettings() {
            const workspace = localStorage.getItem('workspace')

            return JSON.parse(workspace)
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.report = JSON.parse(JSON.stringify(this.reportData))

                if (this.reportStatus === 99) { // Kończenie
                    this.reportAmount = !this.allowsReportExcessAmount ? this.reportLeftAmount : null
                }

                if (this.workspaceSettings.workspaceTypeId === 7) {
                    this.getPrinectAmount()
                }

            } else {
                this.$v.$reset()
                this.report = {}
                this.reportAmount = null
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()
            if (this.$v.$invalid) return
            this.report.reportAmount = this.reportAmount
            this.$emit('on-save', this.report)
        },
        onClose() {
            this.$emit('on-close')
        },
        getPrinectAmount() {
            const payload = {
                plateNumber: this.reportData.plateNumber,
                primaryNumber: this.reportData.objectNumber,
                machineSymbol: this.reportData.machineSymbol
            }

            this.$store.dispatch('reports/getPrinectAmount', payload)
                .then(response => {
                    this.reportAmount = response.amount
                })
                .catch(error => {
                    errorHandler(error)
                })
        }
    }
}
</script>